<template>
  <div class="table">
    <div class="table-content">
      <el-table
        :data="table.tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#F5F7FA',
          color: '#111A34',
          fontWeight: 700,
        }"
      >
        <el-table-column type="index" width="40" fixed> </el-table-column>
        <el-table-column
          v-for="(item, index) in table.tableMenu"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :fixed="item.fixed"
        >
          <template slot-scope="scope">
            <div v-if="item.type === 'link'">
              <div class="logo_link" @click="link(scope.row, item.prop)">
                <!-- @click="handleClick(scope.row, item.prop, 'link')" -->
                <span class="activeColor">{{ scope.row[item.prop] }}</span>
              </div>
            </div>
            <div v-else-if="item.type === 'link_dialog'">
              <div
                class="logo_link"
                @click="handleClick(scope.row, item.prop, 'link_dialog')"
              >
                <span class="activeColor"> {{ scope.row[item.prop] }}</span>
              </div>
            </div>
            <div v-else-if="item.type === 'logo_link'">
              <div class="logo_link">
                <img v-if="scope.row.logo" :src="scope.row.logo" alt="" />
                <div
                  v-else-if="scope.row.shortName"
                  class="activeColor logo_link_name"
                >
                  <div>{{ scope.row.shortName.slice(0, 2) }}</div>
                  <div>{{ scope.row.shortName.slice(2, 4) }}</div>
                </div>
                <div v-else></div>
                <div class="activeColor">
                  <div>{{ scope.row.brand }}</div>
                  <div @click="logoLink(scope.row, item.prop)">
                    {{ scope.row[item.prop] }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="item.type === 'name_and_company'">
              <div class="logo_link">
                <!-- <img v-if="scope.row.logo" :src="scope.row.logo" alt="" /> -->
                <div>
                  <div class="activeColor" style="font-size: 12px">
                    {{ scope.row[item.prop] }}
                    <span @click="addUser(scope.row)">添加老板资料</span>
                  </div>
                  <div
                    class="activeColor"
                    style="font-size: 12px"
                    v-if="scope.row.xidInfo"
                    @click="getCompanyList(scope.row, item.prop)"
                  >
                    关联{{ scope.row.xidInfo.refCompanysCnt }}家公司
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="item.type === 'img'">
              <img
                v-viewer="{ movable: false }"
                class="image"
                :src="scope.row[item.prop]"
                alt=""
              />
            </div>
            <div v-else-if="item.type === 'list'">
              <div
                class="activeColor"
                v-for="item in scope.row[item.prop]"
                :key="item.id"
                @click="handleClick(item, item.prop, 'list')"
              >
                {{ item.name }}
              </div>
            </div>
            <div
              v-else-if="item.type === 'entstatusNameStr'"
              class="entstatusNameStr"
              :style="{
                color: scope.row[item.type].color,
                backgroundColor: scope.row[item.type].bacColor,
                borderColor: scope.row[item.type].borderColor,
              }"
            >
              {{ scope.row[item.type].status }}
            </div>
            <div v-else>
              {{
                scope.row[item.prop] || scope.row[item.prop] === 0
                  ? scope.row[item.prop]
                  : "--"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="table.buttonInfo"
          label="操作"
          fixed="right"
          :width="table.buttonInfo.width"
        >
          <template slot="header">
            操作
            <i
              v-if="table.buttonInfo.add && clientInfo"
              style="cursor: pointer; color: #409eff; font-size: 16px"
              :class="table.buttonInfo.add.icon"
              v-showFunction="{
                active: table.buttonInfo.add.authority,
                array: allFunctionButtons,
              }"
              @click="handleClick('', '', table.buttonInfo.add.active, true)"
            ></i>
          </template>
          <template slot-scope="scope">
            <div
              class="table-button"
              v-for="(it, ind) in table.buttonInfo.list"
              :key="ind"
            >
              <el-button
                v-if="clientInfo"
                :type="it.type"
                :size="it.size"
                :icon="it.icon"
                plain
                v-showFunction="{
                  active: it.authority,
                  array: allFunctionButtons,
                }"
                @click="handleClick(scope.row, it.prop, it.active)"
              >
                {{ it.text }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="table.pageData" class="table-pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="table.pageData.pageIndex"
        :page-size="table.pageData.pageSize"
        layout="prev, pager, next"
        :total="table.pageData.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    table: {
      type: Object,
      default: () => {},
    },
    allFunctionButtons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    getCompanyList(row, prop) {
      console.log("row", row);
      let name = row[prop];
      let pid = row.xidInfo.pid;
      this.$emit("getCompanyList", {
        name,
        pid,
      });
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", this.table);
    },
    link(item, prop) {
      switch (this.table.type) {
        case "ZTBInformation":
          // 招投标
          window.open(item.url, "_blank");
          break;
        case "websiteInfo":
          // 网站或网店信息
          window.open(item[prop], "_blank");
          break;
        default:
          break;
      }
    },
    logoLink(item, prop) {
      let targetRoute = null;
      switch (this.table.type) {
        case "investmentAbroad":
          // 对外投资
          targetRoute = this.$router.resolve({
            name: "Enterprise",
            query: {
              eid: item[prop],
            },
          });
          window.open(targetRoute.href, "_blank");
          break;
        case "branchInformation":
          // 分支机构
          targetRoute = this.$router.resolve({
            name: "Enterprise",
            query: {
              eid: item[prop],
            },
          });
          window.open(targetRoute.href, "_blank");
          break;
        case "investmentAbroadInfo":
          // 对外投资信息
          targetRoute = this.$router.resolve({
            name: "Enterprise",
            query: {
              eid: item[prop],
            },
          });
          window.open(targetRoute.href, "_blank");
          break;
        default:
          break;
      }
    },
    // 添加老板资料
    addUser(item) {
      this.$emit("addUser", {
        type: this.table.type,
        row: item,
      });
    },
    handleClick(item, prop, active, isHeader) {
      let targetRoute = null;
      switch (active) {
        case "link_dialog":
          this.$emit("linkDialog", {
            type: this.table.type,
            prop: prop,
            row: item,
          });
          break;
        case "logo_link":
          targetRoute = this.$router.resolve({
            name: "Enterprise",
            query: {
              eid: item[prop],
            },
          });
          window.open(targetRoute.href, "_blank");
          break;
        case "qualification":
          // 添加资质
          this.$emit("qualification", {
            type: this.table.type,
            row: item,
          });
          break;
        case "add_qualification":
          // 添加资质
          this.$emit("addQualification", {
            type: this.table.type,
            row: item,
            isHeader: isHeader,
          });
          break;
        case "delete_qualification":
          // 删除资质
          this.$emit("deleteQualification", {
            type: this.table.type,
            row: item,
          });
          break;
        case "list":
          // 添加资质
          if (item.eid) {
            targetRoute = this.$router.resolve({
              name: "Enterprise",
              query: {
                eid: item.name,
              },
            });
            window.open(targetRoute.href, "_blank");
          }
          break;
        case "edit_evidence":
          this.$emit("editEvidence", item);
          break;
        case "delete_evidence":
          this.$emit("deleteEvidence", item);
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    console.log("allFunctionButtons", this.allFunctionButtons);
  },
};
</script>

<style lang="less" scoped>
.table {
  display: flex;
  flex-direction: column;
  .table-content {
    width: 100%;
    .logo_link {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 36px;
        height: 36px;
        margin-right: 8px;
        flex-shrink: 0;
      }
      .logo_link_name {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        line-height: 14px;
        border-radius: 4px;
        color: rgb(255, 130, 0);
        background-color: rgba(255, 130, 0, 0.1);
        font-size: 14px;
        margin-right: 8px;
        overflow: hidden;
        flex-shrink: 0;
      }
    }
    .entstatusNameStr {
      display: inline-block;
      height: 22px;
      font-size: 12px;
      padding: 4px 8px;
      line-height: 12px;
      border: 1px solid #d9ecff;
      border-radius: 2px;
    }
    .image {
      width: 60px;
      max-height: 60px;
    }
    .table-button {
      margin-right: 8px;
    }
  }
  .table-pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .activeColor {
    color: #327bf9 !important;
    cursor: pointer;
  }
}
</style>
